export default __webpack_public_path__ + "static/media/F28DC20D-946B-4D32-B4CE-8641F33DA0A5_1_102_o.1801b29d.jpeg";